export default __webpack_public_path__ + "static/media/mec-4.79b9f559.png";